import { render, staticRenderFns } from "./reactivation.vue?vue&type=template&id=599235fa&"
import script from "./reactivation.vue?vue&type=script&lang=js&"
export * from "./reactivation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports